import React from "react";
import { Button, ArrowLeftIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TextButtonWithStartIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Text button with start icon"}
        value={
          '<Button variant={"text"} startIcon={<ArrowLeftIcon />}>Back</Button>'
        }
      >
        <Button variant={"text"} startIcon={<ArrowLeftIcon />}>
          Back
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TextButtonWithStartIcon;
